import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    position: 'absolute',
    top: 54,
    left: 190,
  },

  dotComplete: {
    transform: 'translate(-50%, -50%)',
    width: '10px',
    height: '10px',
    background: '#F4F6F9',
    borderRadius: '50%',
    marginBottom: '124px',
    border: '2px solid #6F9EFF',
  },

  dot: {
    width: '10px',
    height: '10px',
    background: '#E7E9EB',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
  },

  line: {
    width: '2px',
    background: '#E7E9EB',
    position: 'absolute',
    transform: 'translate(-50%)',
  },

  progressArrow: {
    position: 'absolute',
    top: 0,
    zIndex: 2,
    transform: 'translate(-50%, -50%)',
  },
});

class TimelineProgress extends React.Component {
  render() {
    const { classes, statuses } = this.props;

    const defaultHeight = 138;
    const addHeight = 80;
    return (
      <div className={classes.root}>
        <div
          className={classes.line}
          style={{
            height: (statuses.length - 1) * defaultHeight + addHeight + 'px'
          }}
        />
        <div
          className={classes.line}
          style={{
            background: '#6F9EFF',
            height: (statuses.length - 1) * defaultHeight + 'px'
          }}
        />
        <div>
          {statuses.map((status, i) => (
            <div
              id={`dot-${i}`}
              className={i === statuses.length - 1 ? classes.dot : classes.dotComplete}
              style={{
                marginBottom: i === statuses.length - 1 ? '70px' : '124px',
              }}
              key={i} />
          ))}
          <div className={classes.dot} />
        </div>
        <div
          className={classes.progressArrow}
          style={{
            top: (statuses.length - 1) * defaultHeight + 'px'
          }}
        >
          <img
            alt="+" src={require('../../../assets/images/status-bar-arrow-light.png')}
            width="40"
            height="40"
          />
        </div>
      </div>
    );
  }
}

TimelineProgress.propTypes = {
  classes: PropTypes.object.isRequired,
  statuses: PropTypes.array.isRequired,
};

export default withStyles(styles)(TimelineProgress);


// WEBPACK FOOTER //
// ./src/components/Timeline/parts/TimelineProgress.jsx